import { Action, createReducer, createSelector, on } from '@ngrx/store';
import { UserAuthedDTO } from 'src/app/models/DTO/UserAuthedDTO';

import { UserActionTypes } from '../action/userinfo.actions';


export const userredinfoFeatureKey = 'userredinfo';
export interface UserState {
  user: UserAuthedDTO;
}

const initialLoginState: UserState = {
  user: new UserAuthedDTO()
};


export function userReducer(appUserState = initialLoginState, action): UserState {
  switch (action.type) {
    case UserActionTypes.ACTION_LOGOUT:
      return {
        ...appUserState,
        user:  new UserAuthedDTO()
      };
    case UserActionTypes.ACTION_LOGIN:
      let uu = new UserAuthedDTO();   uu =action.payload;
      return {
        ...appUserState,
        // user: new User({
        //   uName: action.payload, //  <-- make sure which value is incoming. may be action.payload.uname based on which value you are dispatching from component.
        //   isAdmin: action.payload, //  <-- make sure which value is incoming.
        //   ts: action.payload, //  <-- make sure which value is incoming.
        //   loggedIn: action.payload //  <-- make sure which value is incoming.
        // })

        user: uu
      };
  }
  return appUserState;
}


export const selectUserState = (state) => state.userState;
export const selectUser = createSelector(selectUserState, (state) => state.user);
